import { IUserLimitsStore } from './types';

export const getUserLimits = (store: IUserLimitsStore) => store.limits;
export const getSetUserLimits = (store: IUserLimitsStore) => store.setLimits;
export const getClearLimits = (store: IUserLimitsStore) => store.clearLimits;

export const getIsLimitsLoading = (store: IUserLimitsStore) => store.isLimitsLoading;
export const getSetIsLimitsLoading = (store: IUserLimitsStore) => store.setIsLimitsLoading;
